import { ICellRendererParams } from 'ag-grid-community';
import { TokenBalance } from '../../types';

const getColorClass = (changePercent: number) => {
  if (changePercent === 0) return 'text-muted-foreground';
  if (changePercent > 0) return 'text-green-600 dark:text-green-400';
  return 'text-red-600 dark:text-red-400';
};

const getSign = (changePercent: number) => {
  if (changePercent === 0) return '';
  if (changePercent > 0) return '+';
  return '-';
};

export const ChangeCellRenderer = (
  params: ICellRendererParams<TokenBalance>,
) => {
  const changePercent = params.value as number;

  if (changePercent === null || changePercent === undefined) {
    return <span className="text-muted-foreground">-</span>;
  }

  const colorClass = getColorClass(changePercent);
  const sign = getSign(changePercent);
  const formattedChange = Math.abs(changePercent).toFixed(2);

  return (
    <span className={`font-mono font-medium ${colorClass}`}>
      {sign}
      {formattedChange}%
    </span>
  );
};
